import React from 'react'
import './macid-style.scss'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@material-ui/core/TextField'
import SearchIcon from '@material-ui/icons/Search'
import InputAdornment from '@mui/material/InputAdornment'
import { useLocation } from 'react-router-dom'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material'
import CompanyLogo from '../../assets/images/electric-pole.png'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete'
import useAddMacidStyles from './styles.js'

const AddMacid = () => {
  const classes = useAddMacidStyles()
  const { state } = useLocation()
  const [searchTerm, setSearchTerm] = React.useState('')
  const [currentPage, setCurrentPage] = React.useState(1)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value)
  }

  const data = [
    { id: 1, name: 'Chemfab Alkalis 1  ', loggers: '2' },
    { id: 2, name: 'Chemfab Alkalis 2  ', loggers: '5' },
    { id: 3, name: 'Chemfab Alkalis 3  ', loggers: '2' },
    { id: 4, name: 'Chemfab Alkalis 4  ', loggers: '5' },
  ]
  const data2 = [
    {
      id: 1,
      macid: '1A32G567TA1013DGH89 ',
      simserial: 'VI45GJ326A546Z7',
      network: 'JIO',
      provider: 'Dongle',
    },
    {
      id: 2,
      macid: '1A32G567TA1013DGH89 ',
      simserial: 'VI45GJ326A546Z7',
      network: 'JIO',
      provider: 'Dongle',
    },
    {
      id: 3,
      macid: '1A32G567TA1013DGH89 ',
      simserial: 'VI45GJ326A546Z7',
      network: 'JIO',
      provider: 'Dongle',
    },
  ]

  const [open1, setOpen1] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)

  const handleOpen = () => {
    setOpen1(true)
  }

  const handleClose = () => {
    setOpen1(false)
  }
  const handleOpen2 = () => {
    setOpen2(true)
  }

  const handleClose2 = () => {
    setOpen2(false)
  }

  const filteredPlantList = state?.plantlist?.filter((row) =>
    row.plantName.toLowerCase().includes(searchTerm.toLowerCase())
  )

  //pagination calculations
  const indexOfLastRow = currentPage * rowsPerPage
  const indexOfFirstRow = indexOfLastRow - rowsPerPage
  const currentRows = filteredPlantList?.slice(indexOfFirstRow, indexOfLastRow) || []
  const totalPages = Math.ceil(filteredPlantList?.length / rowsPerPage)

  return (
    <div className={classes.root} id="macid">
      <Box
        sx={{
          '& .MuiTextField-root': { m: 1, width: '100%' },
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <div className="align_start">
              <div className="w80">
                <div className="searchbar">
                  <TextField
                    placeholder="Search..."
                    disableUnderline
                    onChange={handleSearchChange}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="start" className="pointer">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={7}></Grid>
        </Grid>
      </Box>

      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell className="h_txt">Plant Name</TableCell>
            <TableCell className="h_txt">Sim Serial No.</TableCell>
            <TableCell className="h_txt">Sim Network</TableCell>
            <TableCell className="h_txt">Network Provider</TableCell>
            <TableCell className="h_txt">Dongle Serial No.</TableCell>
            <TableCell className="h_txt">Total Loggers</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentRows?.map((row) => (
            <TableRow onClick={handleOpen} key={row.id}>
              <TableCell>
                <div className="companylogo_bg">
                  <img src={CompanyLogo} alt="company" />
                </div>
              </TableCell>
              <TableCell>{row?.plantName}</TableCell>
              <TableCell>{row?.simSerialNumber}</TableCell>
              <TableCell>{row?.simNetwork}</TableCell>
              <TableCell>{row?.networkProvier}</TableCell>
              <TableCell>{row?.dongleSerialNumber}</TableCell>
              <TableCell>{row?.roofDetails?.length}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div className="pagination-controls">
        <div className="rows-per-page">
          <span>Rows per page: </span>
          <select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            {[5, 10, 25].map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </div>
      
        <div className="page-navigation">
          <span className="page-info">
            {indexOfFirstRow + 1}-{Math.min(indexOfLastRow, filteredPlantList?.length || 0)} of {filteredPlantList?.length || 0}
          </span>
          
          <button 
            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className="pagination-button"
          >
            &lt;
          </button>
          
          <button 
            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
            disabled={currentPage === totalPages || totalPages === 0}
            className="pagination-button"
          >
            &gt;
          </button>
        </div>
     </div>

      <Dialog open={open1} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogActions>
          <ClearIcon onClick={handleClose} className="pointer" />
        </DialogActions>
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="align_start">
              <div className="companylogo_bg">
                <img src={CompanyLogo} alt="company" />
              </div>
              <div className="h_txt">Chemfab Alkalis 1</div>
            </div>

            <div className="add_new_btn" onClick={handleOpen2}>
              <AddCircleIcon className="i_clr" />
              &nbsp; Add New Device
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell className="h_txt">MAC ID</TableCell>
                <TableCell className="h_txt">Sim Serial No.</TableCell>
                <TableCell className="h_txt">Sim Network</TableCell>
                <TableCell className="h_txt"> Network Provider</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data2.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>1</TableCell>
                  <TableCell>{row.macid}</TableCell>
                  <TableCell>{row.simserial}</TableCell>
                  <TableCell>{row.network}</TableCell>
                  <TableCell>{row.provider}</TableCell>
                  <TableCell>
                    <DeleteIcon className="i_clr" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>

      <Dialog
        className="businessview_dialog"
        open={open2}
        onClose={handleClose2}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <div className="align_btw brdr">
            <div className="align_start">
              <div className="companylogo_bg">
                <img src={CompanyLogo} alt="company" />
              </div>
              <div className="h_txt">Chemfab Alkalis 1</div>
            </div>

            <DialogActions>
              <ClearIcon onClick={handleClose2} className="pointer" />
            </DialogActions>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="txt_12">Add New Device</div>
          <br />
          <Box
            sx={{
              maxWidth: '100%',
            }}
          >
            <TextField fullWidth label="Enter Device ID" id="fullWidth" />
          </Box>

          <DialogActions>
            <button className="save_btn">Save</button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  )
}

AddMacid.propTypes = {}

export default AddMacid
